import React, { useMemo } from "react";
import { Icon, ThemedIcon } from "@me8eon/icons";
import TypingEffect from "../../../components/ai-assist-refactored/utils/typing-effect/TypingEffect";
import "./sustainableIT.component.scss";
import { WidgetComponent } from "../widget.types";
import { NexthinkActionWidgetMeta } from "@me8eon/ai.tools.nextthink/src/model/nexthinkWidget";
import { useLocalTranslation } from "./useLocalTranslation";

export const SustainableItActionWidget: WidgetComponent = (props) => {
    const values = props.values._meta.widget as NexthinkActionWidgetMeta;
    const { document, reportData, queryLanguage } = values.props;
    const { localT } = useLocalTranslation(queryLanguage);

    const ReportContent = useMemo(() => {
        if (!reportData) return null;
        return (
            <div className="report-content">
                <div className="device-info">
                    <div className="device-label">
                        {localT("chatBot.nexthinkIntegration.device")}
                        <span className="icon">
                            <ThemedIcon name="deviceIcon" />
                        </span>
                    </div>
                    <div className="device-name">
                        {reportData.deviceName}{" "}
                        <span className="virtual-tag">
                            {reportData.hardwareType}
                        </span>
                    </div>
                    <div className="uptime">
                        <div className="restart-days">
                            <Icon
                                name={
                                    reportData.lastBootRating === "poor"
                                        ? "bad_rating"
                                        : "tick_small"
                                }
                                themedColor={
                                    reportData.lastBootRating === "poor"
                                        ? "#EA1B0A"
                                        : "#00B876"
                                }
                            />
                            <span>
                                {" "}
                                {reportData.daysSinceLastBoot}{" "}
                                {localT("chatBot.nexthinkIntegration.days")}
                            </span>
                        </div>
                        <span className="virtual-tag">
                            {localT("chatBot.nexthinkIntegration.sinceRestarted")}
                        </span>
                        <span className="recommendation">
                            <Icon
                                name={
                                    reportData.lastBootRating === "poor"
                                        ? "bulb_green"
                                        : "thumb_up"
                                }
                                themedColor="#34C759"
                            />
                            <span>
                                {reportData.lastBootRating === "poor"
                                    ? localT(
                                        "chatBot.nexthinkIntegration.deviceRestartRecommendation"
                                    )
                                    : localT(
                                        "chatBot.nexthinkIntegration.deviceInCompliance"
                                    )}
                            </span>
                        </span>
                    </div>
                </div>
                <div className="energy-info">
                    <div className="energy-consumed">
                        <div className="device-label">
                            {localT("chatBot.nexthinkIntegration.energyConsumed")}
                            <span className="icon">
                                <ThemedIcon name="bulb" />
                            </span>
                        </div>
                        <div>
                            <span className="value">
                                {reportData?.totalEnergyConsumption != null
                                    ? (
                                        reportData.totalEnergyConsumption /
                                        1000
                                    ).toFixed(2)
                                    : ""}
                            </span>
                            <span className="unit"> kWh</span>
                        </div>
                    </div>
                    <div className="energy-emitted">
                        <div className="device-label">
                            {localT("chatBot.nexthinkIntegration.coEmitted")}
                            <span className="icon">
                                <ThemedIcon name="co2" />
                            </span>
                        </div>
                        <div>
                            <span className="value">
                                {reportData.totalCO2Emitted?.toFixed(3) ?? ""}{" "}
                            </span>
                            <span className="unit">gms</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }, [reportData, localT]);

    if (!reportData) {
        return (
            <div className="bot-header">
                {localT("chatBot.nexthinkIntegration.errorFetchingReport")}
            </div>
        );
    }

    return (
        <div className="bot-header">
            <div className="bot-reply-container">
                <div className="title">
                    {localT("chatBot.nexthinkIntegration.itReportTitle")}
                </div>
                {ReportContent}
                <div className="compliance">
                    <TypingEffect
                        className="bot-text"
                        text={`${document.response}<br/><br/><b>Source: Nexthink</b>`}
                        speed={1}
                    />
                </div>
            </div>
        </div>
    );
};
